import React, { useState } from "react";
import { Button } from "reactstrap";
import Head from "./Head";
import "./index.scss";
import Info from "./Info";
import Tags from "./Tags";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFile, rightsidebar } from "../../../../context/actions/document";
const FileDetail = ({ document, tags, folder, deleteDocument, restoreDocument, search }) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const userData = useSelector((state) => state.user.user);
	const [disabled, setDisabled] = useState(false);
	const editDocument = () => {
		setDisabled(true);
		dispatch({ type: "ISLOADING", data: true });
		dispatch({ type: "UPDATE_DOCUMENT_FILTER", data: search });
		dispatch(rightsidebar('D'));
		dispatch(
			getFile({ docId: document._id, Au: null, pageNumber: 1 }, (result) => {
				if (result) {
					history.push("/documentDetail");
				}
				setDisabled(false)
			})
		);
	}
	/*useEffect(() => {
		if (!userData?.current_subscription || userData?.current_subscription?.subscription_status !== 'active')
			setDisabled(true)	
	}, [userData])*/

	return (
		<>
			<div className="file-detail">
				<Head data={document} />
				<div className="inner">
					<Info data={document} />
					<Tags tags={tags} />
					{/* {!document.deleted && <div className="action-btns d-flex">
						<div className="cell">
							<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => editDocument()}>Edit</Button>
						</div>
						<div className="cell">
							<Button color="danger" disabled={!userData?.purchase_advice && folder?.type === 'purchase advice'} onClick={() => deleteDocument(document._id)} >Archive</Button>
						</div>
					</div>}
					{document.deleted && <div className="action-btns d-flex">
						<div className="cell">
							<Button color="primary" disabled={disabled || (!userData?.purchase_advice && folder?.type === 'purchase advice')} onClick={() => restoreDocument(document._id)}>Restore</Button>
						</div>

					</div>} */}
				</div>
			</div>
		</>
	);

}

export default FileDetail;